document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.ss-styles-slider', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    centeredSlides: false,
    freeMode: true,
    grabCursor: true
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const modals = document.querySelectorAll('.smelter-modal-body');

  modals.forEach(function(modalBody) {
    const fadeout = modalBody.querySelector('.smelter-modal-fadeout');
    if (!fadeout) return;

    modalBody.addEventListener('scroll', function () {
      const isAtBottom = modalBody.scrollHeight - modalBody.scrollTop <= modalBody.clientHeight + 2;
      fadeout.style.opacity = isAtBottom ? '0' : '1';
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const hero = document.querySelector('.ss-hero-wrapper');
  if (!hero) return;

  function updateBackground() {
    const width = window.innerWidth;
    let imageUrl = hero.dataset.desktop;

    if (width <= 768) {
      imageUrl = hero.dataset.mobile;
    } else if (width <= 1024) {
      imageUrl = hero.dataset.tablet;
    }

    hero.style.backgroundImage = `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 78.22%, #000 100%), url(${imageUrl})`;
  }

  updateBackground();
  window.addEventListener('resize', updateBackground);
});